module.exports = __webpack_public_path__ + "pic/7.23c6081f.png";